// extracted by mini-css-extract-plugin
export default {"Divider":"VoQSRLWL","Horizontal":"vY2bOmYv","Vertical":"XMYib3gR"};